import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { DFA_LOGO_SRC, programmeClassLabel } from "@/pages/identityCardUtils";
export default function VerifyIdentityCard() {
  const { token } = useParams();
  const [card, setCard] = useState(null),
    [error, setError] = useState(false);
  useEffect(() => {
    api
      .get(`/public/id-cards/verify/${encodeURIComponent(token)}`)
      .then((r) => setCard(r.data))
      .catch(() => setError(true));
  }, [token]);
  if (error)
    return (
      <main className="grid min-h-screen place-items-center">
        <h1 className="text-2xl text-red-700">Card not verified</h1>
      </main>
    );
  if (!card)
    return (
      <main className="grid min-h-screen place-items-center">Verifying…</main>
    );
  return (
    <main className="grid min-h-screen place-items-center bg-[#FDFBF7] p-5">
      <section className="w-full max-w-md rounded-2xl border bg-white p-6 shadow">
        <img src={DFA_LOGO_SRC} alt="Darussalam Foundation Academy" className="mx-auto h-24 w-24 object-contain" />
        <h1 className="mt-3 text-center font-display text-2xl">
          Verified {card.person_type} ID
        </h1>
        {card.photo && (
          <img
            src={card.photo}
            alt="Identity"
            className="mx-auto mt-4 h-28 w-24 rounded object-cover"
          />
        )}
        <dl className="mt-5">
          {[
            ["Name", card.full_name],
            [
              card.person_type === "student" ? "Admission number" : "Staff ID",
              card.identity_number,
            ],
            ["Position", card.position],
            ["Unit", card.unit],
            ["Card status", card.card_status],
          ]
            .filter((x) => x[1])
            .map(([k, v]) => (
              <div className="flex justify-between border-b py-2" key={k}>
                <dt>{k}</dt>
                <dd className="font-medium">{v}</dd>
              </div>
            ))}
        </dl>
        {card.person_type === "student" && card.programmes?.length > 0 && (
          <section className="mt-5 rounded-xl bg-slate-50 p-4">
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#63822D]">Programmes / Classes</h2>
            <ul className="mt-2 space-y-2">
              {card.programmes.map((placement, index) => (
                <li key={`${placement.program}-${placement.class_name}-${index}`} className="text-sm">
                  {programmeClassLabel(placement)}
                </li>
              ))}
            </ul>
          </section>
        )}
      </section>
    </main>
  );
}
